import React, { useState } from "react";
import { FinancialTarget } from "./Dashboard";
import { addCommas } from "../../App";

const DashboardCard = ({ title, value, subvalue, highlight, isDark }) => (
  <div
    className={`${isDark ? 'bg-dark text-white border-white' : 'bg-white text-dark border-white'} h-100 p-3 rounded border d-flex flex-column align-items-center justify-content-center text-center`}
    style={{
      minHeight: '120px',
      backgroundColor: isDark ? '#000' : '#fff',
      borderWidth: '10px'
    }}
  >
    <div className="text-uppercase fw-semibold mb-2 text-truncate text-uppercase mb-2" style={{ fontSize: '1.3rem', whiteSpace: "nowrap" }}>
      {title}
    </div>
    <div
      className={`display-6 fw-bold ${highlight ? '' : ''}`}
      style={{ fontSize: '2rem', color: highlight ? '' : '' }}
    >
      {value}
    </div>
    {/* {subvalue && (
      <div
        className={`${isDark ? 'text-white' : 'text-dark'}  mt-1 text-truncate `}
        style={{
          fontSize: '1.8rem',
          whiteSpace: "nowrap"
        }}
      >
        {subvalue}
      </div>
    )} */}

  </div>
);


const SectionTitle = ({ children, isDark }) => (
  <h2 className={`${isDark ? 'text-white border-secondary' : 'text-dark border-dark'} h4 fw-semibold text-uppercase text-center mb-4`}
    style={{ letterSpacing: '0.15em' }}>
    {children}
  </h2>
);

const ThemeToggle = ({ isDark, onToggle }) => (
  <div className="position-fixed top-0 end-0 m-4" style={{ zIndex: 1000, display: "none" }}>
    <button
      style={{ border: "none", background: "none" }}
      onClick={onToggle}
    >
      {isDark ? (
        <>
          <i className="fas fa-sun me-2" style={{ color: "white" }}></i>
        </>
      ) : (
        <>
          <i className="fas fa-moon me-2" ></i>
        </>
      )}
    </button>
  </div>
);

export default function Dashboardv2({ categories, summaryData, performanceData, currentStats, financialData, openTickets, data }) {
  const [isDarkMode, setIsDarkMode] = useState(true);
  const toggleTheme = () => {
    setIsDarkMode(!isDarkMode);
  };

  return (
    <div
      className={`${isDarkMode ? 'bg-dark text-white' : 'bg-light text-dark'} p-4`}
      style={{
        minHeight: '100vh',
        backgroundColor: isDarkMode ? '#000' : '#f8f9fa',
        transition: 'all 0.3s ease'
      }}
    >

      <div className="container-fluid">
        {/* Bootstrap CSS and Font Awesome CDN */}
        <link
          href="https://cdnjs.cloudflare.com/ajax/libs/bootstrap/5.3.0/css/bootstrap.min.css"
          rel="stylesheet"
        />
        <link
          href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css"
          rel="stylesheet"
        />

        <ThemeToggle isDark={isDarkMode} onToggle={toggleTheme} />

        <div className="">
          <SectionTitle isDark={isDarkMode}>ENGINEERING DEPARTMENT</SectionTitle>
        </div>

        {/* Top Summary */}
        <div className="row g-1">
          {summaryData?.map((item, index) => (
            <div key={index} className="col-12 col-sm-6 col-lg-3">
              <DashboardCard
                title={item.label}
                value={item.label === 'Not Allocated' ? performanceData?.find(row => row.name == "Not Allocated")?.tickets || 0 : item.value}
                isDark={item.label === "Not Allocated" || item?.label == "Current Job's(NEW)" ? false : isDarkMode}
                highlight={item.label === "Not Allocated"}
                subvalue={item.subvalue ? item.subvalue : null}
              />
            </div>
          ))}
        </div>


        <div className="mt-4">
          <SectionTitle isDark={isDarkMode}>JOB'S COMPLETED</SectionTitle>
        </div>
        <div className="row g-1">
          {currentStats.map((stat, index) => (
            <div key={index} className="col-12 col-sm-6 col-lg-3">
              <DashboardCard
                title={stat.title}
                value={stat.value}
                subvalue={stat.subvalue}
                isDark={stat.title == "TODAY" ? false : isDarkMode}
              />
            </div>
          ))}
        </div>



        <div className="mt-4">
          <SectionTitle isDark={isDarkMode}>FINANCIAL TARGETS & PROJECTIONS</SectionTitle>
        </div>
        <div className="row g-4">

          <div className="col-12 col-lg-8">
            <div className="row g-1">
              {financialData && financialData?.map((item) => (
                <div className="col-12 col-sm-6 col-xl-3" key={item.id}>
                  <FinancialTarget
                    title={item.Period.toUpperCase()}
                    value={item.Period?.toLowerCase() != "this year" ? `£${data?.progressCards[item?.id - 1]?.value.toFixed()}` : `£${item.Value.toLocaleString()}` }
                    percentage={ item.Period?.toLowerCase() != "this year" ? `Completed ${((data?.progressCards[item?.id - 1]?.value.toFixed()/item.Target)*100).toFixed(2)}%` : `Completed ${item.Completed.toFixed(2)}%`}
                    color={item.Color}
                    goal={`Target £${item.Target.toLocaleString()}`}
                    isDark={isDarkMode}
                    projected={
                      item.Period?.toLowerCase() === "this year" || item.Period?.toLowerCase() === "this month"
                        ? `Projected ${Number(item?.["Projected Month"]) < 0
                          ? `-£${Math.abs(Number(item?.["Projected Month"])).toLocaleString("en-UK")}`
                          : `£${Number(item?.["Projected Month"]).toLocaleString("en-UK")}`}`
                        : false
                    }

                    variance={
                      item.Period?.toLowerCase() === "this year" || item.Period?.toLowerCase() === "this month"
                        ? `Variance ${Number(item?.Variance) < 0
                          ? `-£${Math.abs(Number(item?.Variance)).toLocaleString("en-UK")}`
                          : `£${Number(item?.Variance).toLocaleString("en-UK")}`}`
                        : false
                    }
                  />
                </div>
              ))}
            </div>
          </div>

          <div className="col-12 col-lg-4">
            <div className="row ">
              <div className="col-12 h-100">
                <div
                  className={`${isDarkMode ? 'bg-dark border-white' : 'bg-light border-dark'} border  overflow-hidden`}
                  style={{ backgroundColor: isDarkMode ? '#000' : '#fff', borderRadius: "5px" }}
                >
                  <table className={`table ${isDarkMode ? 'table-dark' : 'table-light'} table-bordered text-center mb-0`}>
                    <thead>
                      <tr style={{ fontSize: '1.2rem' }}>
                        <th className={`p-3 fw-semibold ${isDarkMode ? 'border-secondary' : 'border-dark'}`}>Month to Date</th>
                        <th className={`p-3 fw-semibold ${isDarkMode ? 'border-secondary' : 'border-dark'}`}>Projected Month</th>
                        <th className={`p-3 fw-semibold ${isDarkMode ? 'border-secondary' : 'border-dark'}`}>Variance</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr style={{ fontSize: '1.5rem' }}>
                        {financialData[2] && (<><td className={`p-3 fw-semibold ${isDarkMode ? 'border-secondary' : 'border-dark'}`}>{`£${financialData[2]['Month to Date'].toLocaleString()}`}</td>
                          <td className={`p-3 fw-semibold ${isDarkMode ? 'border-secondary' : 'border-dark'}`}>{`£${financialData[2]['Projected Month'].toLocaleString()}`}</td>
                          <td
                            className={`p-3 text-danger fw-bold ${isDarkMode ? "border-secondary" : "border-dark"
                              }`}
                          >
                            {Number(financialData[2]["Variance"]) < 0
                              ? `-£${Math.abs(Number(financialData[2]["Variance"])).toLocaleString("en-UK")}`
                              : `£${Number(financialData[2]["Variance"]).toLocaleString("en-UK")}`}
                          </td>
                        </>)}
                      </tr>
                    </tbody>
                  </table>
                </div>

              </div>

              <div className="col-12 h-100 " style={{ borderTop: "none", borderRadius: "5px" }}>
                <div
                  className={`${isDarkMode ? 'bg-dark border-white text-white' : 'bg-light border-dark text-dark'} border  border-top-0`}
                  style={{ backgroundColor: isDarkMode ? '#000' : '#fff', display: "flex", justifyContent: "space-around", alignItems: "center", borderRadius: "5px" }}
                >
                  <div className="py-4 px-5" style={{ borderRight: isDarkMode ? '1px solid #fff' : '1px solid #000' }}>
                    <h5 className="h5 fw-semibold mb-1 text-center">TOTAL OPEN TICKET</h5>
                    <p className="text-danger fw-bold mb-0 text-center" style={{ fontSize: '1.8rem' }}>
                      {openTickets?.count}
                    </p>
                  </div>
                  <div className="p-2">
                    <h5 className="h5 fw-semibold mb-1 text-center">PROJECTED VALUE OF TICKETS</h5>
                    <p className="text-danger fw-bold mb-0 text-center" style={{ fontSize: '1.8rem' }}>
                      {openTickets?.value}
                    </p>
                  </div>
                </div>

              </div>

            </div>
          </div>

        </div>

      </div>
      <div className="mt-4">
        <SectionTitle isDark={isDarkMode}>CURRENT JOB'S BY CATEGORY</SectionTitle>
      </div>
      <div className="row g-1">
        {categories.length > 0 && categories.map((item, index) => (
          <div key={index} className="col-6 col-md-4 col-lg-2">
            <DashboardCard title={item.label == "Radio/CD/Navigation Repair" ? "Radio/CD /Navigation Repair" : item.label} value={item.count} isDark={isDarkMode}
              subvalue={item?.total_retail ? `Potential Value: ${addCommas(`£${item.total_retail.toFixed(0)}`)}` : "Potential Value: £0"}

            />
          </div>
        ))}
      </div>
    </div>
  );
}


{/*
      <div className="row mt-4">
        <h1 className="text-center mb-4">Performance data this month</h1>
        <div className="col-12">
          <table className="table table-bordered table-striped text-center">
            <thead className="thead-dark">
              <tr>
                <th>Engineer</th>
                <th>Total Tickets</th>
                <th>Total Reworks</th>
                <th>Rework %</th>
                <th>NFF</th>
                <th>BR</th>
                <th>Not Successful</th>
                <th>ENG Successful Job</th>
              </tr>
            </thead>
            <tbody>
              {performanceData?.filter(row => row.name != "Not Allocated").map((row, index) => (
                <tr key={index}>
                  <td>{row.name}</td>
                  <td>{row.tickets}</td>
                  <td>{row.reworks}</td>
                  <td>
                    <span
                      style={{
                        display: "inline-block",
                        padding: "5px 20px",
                        borderRadius: "15px",
                        backgroundColor:
                          row.reworkPercent >= 15
                            ? "red"
                            : row.reworkPercent >= 10
                              ? "orange"
                              : "green",
                        color: "white",
                        fontWeight: "bold",
                      }}
                    >
                      {row.reworkPercent}%
                    </span>
                  </td>
                  <td>{row.NFF}</td>
                  <td>{row.BR}</td>
                  <td>{row.NS}</td>
                  <td>{row.SJ}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div> Table Section */}